// extracted by mini-css-extract-plugin
export var centerText = "_dn-8";
export var container = "_dn-0";
export var doughnutContainer = "_dn-7";
export var legend = "_dn-a";
export var legendItemColorDisplay = "_dn-b";
export var legendItemLabel = "_dn-d";
export var legendItemValue = "_dn-c";
export var lg = "_dn-5";
export var maxWidth = "_dn-9";
export var md = "_dn-4";
export var responsive = "_dn-6";
export var sm = "_dn-3";
export var xs = "_dn-2";
export var xxs = "_dn-1";